import { Box } from '@wix/design-system';
import React, { forwardRef, ReactNode } from 'react';

import { renderModel } from '../../../util/renderModel';
import s from './MessageItem.scss';

const isFullWidth = renderModel.isFullWidth();

interface MessageItemProps {
  id: string;
  children: ReactNode;
  dataHook?: string;
  fromUser?: boolean;
  /**
   * 'fit-content' - message item will take the width of its content
   * 'standard' - message will take full width in widget mode and 480px in full screen mode
   * 'full' - message will take all the available width
   */
  width?: 'fit-content' | 'standard' | 'full';
}

export const MessageItem = forwardRef<HTMLDivElement, MessageItemProps>(
  ({ id, children, fromUser = false, width = 'standard', dataHook }, ref) => {
    const sideMargin = isFullWidth ? 'SP4' : 'SP2';

    return (
      <Box
        ref={ref}
        direction="vertical"
        align={fromUser ? 'right' : 'left'}
        marginLeft={fromUser ? sideMargin : undefined}
        marginRight={!fromUser ? sideMargin : undefined}
      >
        <Box
          direction="vertical"
          maxWidth={width === 'full' ? '100%' : '480px'}
          width={width !== 'fit-content' ? '100%' : undefined}
        >
          <div className={s.item} data-message-id={id} data-hook={dataHook}>
            {children}
          </div>
        </Box>
      </Box>
    );
  },
);
